/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.options.rpc.PurchaseOptionsService
 */

export let ComHubspotPurchaseOptionsModelsRpcAbstractIndependentPurchasableProductsError;
(function (_ComHubspotPurchaseOptionsModelsRpcAbstractIndependentPurchasableProductsError) {})(ComHubspotPurchaseOptionsModelsRpcAbstractIndependentPurchasableProductsError || (ComHubspotPurchaseOptionsModelsRpcAbstractIndependentPurchasableProductsError = {}));
export let ComHubspotPurchaseOptionsModelsRpcAbstractPurchaseOptionsError;
(function (_ComHubspotPurchaseOptionsModelsRpcAbstractPurchaseOptionsError) {})(ComHubspotPurchaseOptionsModelsRpcAbstractPurchaseOptionsError || (ComHubspotPurchaseOptionsModelsRpcAbstractPurchaseOptionsError = {}));
export const AnonymousUserContextTypename = 'com.hubspot.purchase.options.models.rpc.context.AnonymousUserContext';
export const AssistedUserContextTypename = 'com.hubspot.purchase.options.models.rpc.context.AssistedUserContext';
export const TouchlessUserContextTypename = 'com.hubspot.purchase.options.models.rpc.context.TouchlessUserContext';
export const findAllPurchasableProductsRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findAllPurchasableProducts',
  auth: 'app',
  fingerprint: 'BGHLD0kD78qQw5mnJg9QhOqDBJXDb_F_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findIndependentPurchasableProductsRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findIndependentPurchasableProducts',
  auth: 'app',
  fingerprint: '72L_LwvGH6jjzHd2oAbrfYPwVjMz_ejb',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findPurchaseOptionsRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findPurchaseOptions',
  auth: 'app',
  fingerprint: 'Ib-xwaLGp7l4mV-kZTZ-8uqDBJXDb_F_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findPurchaseRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findPurchase',
  auth: 'app',
  fingerprint: '9bzCLVCpIhMtngO5xAviIOqDBJXDb_F_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findPackagedQuantityPurchaseOptionsRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findPackagedQuantityPurchaseOptions',
  auth: 'app',
  fingerprint: 'ZCZJOshVavIuo8espUIC4-qDBJXDb_F_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findQuantityPackPricingTiersRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findQuantityPackPricingTiers',
  auth: 'app',
  fingerprint: 'AxktnH-haXY05qP2vTYNNOqDBJXDb_F_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};